import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SampleGroupService} from "../../../../services/sample-group.service";
import {NavBarComponent} from "../../../../nav-bar/nav-bar.component";


@Component({
  selector: 'app-new-save-grid',
  templateUrl: './new-save-grid.component.html',
  styleUrl: './new-save-grid.component.css',
  standalone:false
})
export class NewSaveGridComponent {
  saveGridForm: FormGroup;
  isSaving: boolean = false;

  totalPins: number = 0;
  savedPins: number = 0;
  failedPins: number = 0;
  // isSavingPins: boolean = false;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<NewSaveGridComponent>,
      private sampleGroupService: SampleGroupService,
      private nav: NavBarComponent
  ) {
    this.saveGridForm = new FormGroup({
      gridName: new FormControl(null, [Validators.required])
    });
  }

  cancel() {
    this.dialogRef.close({option: 'cancel'});
  }

  saveGrid() {
    this.saveGridForm.markAllAsTouched();
    if (!this.saveGridForm.valid) return;

    this.nav.toggleLoading(true);
    this.dialogRef.close();

    this.sampleGroupService.insertSampleGroup(
        this.saveGridForm.controls.gridName.value,
        this.data.tenantId,
        this.data.userId,
        true,
        this.data.gridRotation,
        this.data.gridSpacing
    )
        .subscribe({
          next: (sampleGroup) => {
            const points: any[] = this.data.markers ?? [];

         if (points.length === 0) {
          this.nav.toggleLoading(false);
          this.data.onSaveComplete({
            sampleGroup,
            pinResults: [],
            savedCount: 0,
            failedCount: 0,
          });
          return;
        }

        this.totalPins = points.length;
        this.savedPins = 0;
        this.failedPins = 0;

        this.sampleGroupService.insertGriddingPins(
            points,
            sampleGroup.id,
            this.data.fieldId,
            this.data.tenantId,
            this.data.userId
        ).subscribe({
          next: (results) => {
            this.savedPins = results.filter((r) => r.success).length;
            this.failedPins = results.filter((r) => !r.success).length;
            this.nav.toggleLoading(false);
            this.data.onSaveComplete({
              sampleGroup,
              pinResults: results,
              savedCount: this.savedPins,
              failedCount: this.failedPins,
            });
          },
          error: (err) => {
            this.nav.toggleLoading(false);
            this.data.onSaveComplete({
              sampleGroup,
              pinResults: [],
              savedCount: 0,
              failedCount: points.length,
            });
          },
        });
      },
      error: (err) => {
        this.nav.toggleLoading(false);
      },
    });
  }
}